import { IEquipmentInvoiceLine } from 'features/inventory/equipment-invoices/types';
import { axiosPrivate } from 'shared/api';
import { BaseService } from 'shared/services/BaseService';

class EquipmentInvoiceLineService extends BaseService<IEquipmentInvoiceLine> {
  constructor() {
    super('equipment-invoice-lines');
    this.canDelete = true;
  }

  getUnassigned = async (limit = 25, offset = 0, params: Record<string, unknown> = {}) => {
    const res = await axiosPrivate.get(`${this.modulePrefix}/unassigned/`, {
      params: { limit, offset, ...params }
    });
    return res.data;
  };
}

export const equipmentInvoiceLineService = new EquipmentInvoiceLineService();
